import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../logo-quadrato.png";

export default function MarketingNavbar() {

  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
const [soluzioniOpen, setSoluzioniOpen] = useState(false);
  return (
    <nav className="hp-nav">

      <img
        src={logo}
        alt="QrMenu-Italia"
        className="hp-nav-logo"
        onClick={() => navigate("/")}
        style={{ cursor: "pointer" }}
      />
<button
  className="hp-nav-mobile-btn"
  onClick={() => setMobileOpen(!mobileOpen)}
>
  ☰
</button>

      <div className={`hp-nav-links ${mobileOpen ? "open" : ""}`}>

        <button
          className="hp-nav-ghost"
          onClick={() => {
  navigate("/");
  setMobileOpen(false);
}}
        >
          Home
        </button>

<div
  className="hp-nav-dropdown"
  onMouseEnter={() => setSoluzioniOpen(true)}
  onMouseLeave={() => setSoluzioniOpen(false)}
>
  <button
    className="hp-nav-ghost"
    onClick={() => setSoluzioniOpen((prev) => !prev)}
    aria-expanded={soluzioniOpen}
  >
    Soluzioni {soluzioniOpen ? "▴" : "▾"}
  </button>

  {soluzioniOpen && (
    <div className="hp-nav-dropdown-menu">

      <button
        onClick={() => {
          navigate("/piani");
          setMobileOpen(false);
          setSoluzioniOpen(false);
        }}
      >
        Piani
      </button>

      <button
        onClick={() => {
          navigate("/menu-digitale-ristoranti");
          setMobileOpen(false);
          setSoluzioniOpen(false);
        }}
      >
        Ristoranti e Pizzerie
      </button>

      <button
        onClick={() => {
          navigate("/street-food");
          setMobileOpen(false);
          setSoluzioniOpen(false);
        }}
      >
        Street Food
      </button>

      <button
        onClick={() => {
          navigate("/app-asporto");
          setMobileOpen(false);
          setSoluzioniOpen(false);
        }}
      >
        Asporto
      </button>

    </div>
  )}
</div>

        <button
          className="hp-nav-ghost"
          onClick={() => {
  navigate("/menu-ai");
  setMobileOpen(false);
}}
        >
          Intelligenza Artificiale
        </button>



        <button
          className="hp-nav-demo"
          onClick={() => {
  navigate("/demo");
  setMobileOpen(false);
}}
        >
          Prova Gratis
        </button>

<button
  className="hp-nav-ghost"
  onClick={() => {
    navigate("/partner");
    setMobileOpen(false);
  }}
>
  Partner
</button>

        <button
          className="hp-nav-cta"
          onClick={() => {
  navigate("/login");
  setMobileOpen(false);
}}
        >
          Accedi
        </button>

      </div>

    </nav>
  );
}